import React from "react";
import { Outlet } from "react-router-dom";

const ClinicWrapper: React.FC = () => {
  return <Outlet />;
};

export default ClinicWrapper;
